import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';

function scaleVideoSprite(videoSprite: PIXI.Sprite) {
	let scale = (FBRConstants.STAGE_WIDTH*0.7)/videoSprite.width;
	videoSprite.scale = new PIXI.Point(scale, scale);
}

const createNoiceOverlay = (
	noiceVideos: HTMLVideoElement[],
	//pixiAppRef: MutableRefObject<PIXI.Application | undefined>,
	//globalState: MutableRefObject<FBRTypes.GlobalState>,
) => {
	const noiceSprites: PIXI.Sprite[] = [];

	noiceVideos.forEach( (videoElement) => {
		const videoResource = new PIXI.VideoResource(videoElement);
		videoResource.updateFPS = 30;
		videoResource.source.loop = true;
		videoResource.source.muted = true;
		const videoSprite = new PIXI.Sprite(PIXI.Texture.from(videoResource.source));
		scaleVideoSprite(videoSprite);
		videoSprite.anchor.set(0.5, 0.5);
		noiceSprites.push(videoSprite);
	});

	const primaryContainer = new PIXI.Container();
	const currentVideoContainer = new PIXI.Container();
	currentVideoContainer.x = FBRConstants.STAGE_WIDTH/2;
	currentVideoContainer.y = FBRConstants.STAGE_HEIGHT/2;
	
	primaryContainer.addChild(currentVideoContainer);	

	let showNoiceVideo = false;

	const _update = (() => {
		const currentVideoTimeout = 135;
		let currentVideoCount = 0;
		let containerHasVideo = false;
		return () => {
			if(showNoiceVideo) {
				//show new video
				const newSpriteIndex = Math.floor(noiceSprites.length*Math.random());
				console.log(`noiceSprites index = ${newSpriteIndex}`);
				const newSprite = noiceSprites[newSpriteIndex];	
				currentVideoContainer.removeChildren();
				currentVideoContainer.addChild(newSprite);
				showNoiceVideo = false;
				containerHasVideo = true;
				currentVideoCount = 0;
			} else if (containerHasVideo && currentVideoCount === currentVideoTimeout) {
				currentVideoContainer.removeChildren();
				containerHasVideo = false;		
			}
			if(containerHasVideo && currentVideoCount < currentVideoTimeout) {
				currentVideoCount += 1;
				currentVideoContainer.rotation += 0.03;
				currentVideoContainer.scale.x = 1 + Math.sin(currentVideoCount/15) * 0.075;
		    currentVideoContainer.scale.y = 1 + Math.cos(currentVideoCount/15) * 0.075;
				console.log(`currentVideoCount=${currentVideoCount}, currentVideoTimeout=${currentVideoTimeout}`);
			}
		}
	})();
	
	const _showNoiceVideo = () => {
		showNoiceVideo = true;
	}

	return {
		container: primaryContainer,
		update: _update,
		showNoiceVideo: _showNoiceVideo,
	};
};

export default createNoiceOverlay;
